module.exports = __webpack_public_path__ + "img/consulting.d59cc63.svg";